export default "__VITE_ASSET__Ce_crXh5__"